{
  "$id": "wealthlane://forms/performance-rule/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [
    {
      "id": "clearMaximumWhenMinimumChanges",
      "watch": "minimumPercentage",
      "clear": ["maximumPercentage"]
    },
    {
      "id": "syncEvaluationBoundsFromMinimum",
      "watch": "minimumPercentage",
      "set": {
        "performanceEvaluation.minValue": {
          "operator": "field",
          "name": "minimumPercentage"
        }
      }
    },
    {
      "id": "syncEvaluationBoundsFromMaximum",
      "watch": "maximumPercentage",
      "set": {
        "performanceEvaluation.maxValue": {
          "operator": "field",
          "name": "maximumPercentage"
        }
      }
    }
  ],
  "arrayRules": {
    "estimatePerformanceTrackings": {
      "arrayEffects": [
        {
          "id": "syncTrackingBoundsFromMinimum",
          "watch": ["minimumPercentage"],
          "perRow": {
            "minValue": { "operator": "field", "name": "^minimumPercentage" }
          },
          "preserveUserEdits": false
        },
        {
          "id": "syncTrackingBoundsFromMaximum",
          "watch": ["maximumPercentage"],
          "perRow": {
            "maxValue": { "operator": "field", "name": "^maximumPercentage" }
          },
          "preserveUserEdits": false
        }
      ],
      "itemRowObservers": [
        {
          "watch": "multiplierPercentage",
          "target": "minValue",
          "compute": { "operator": "field", "name": "^minimumPercentage" },
          "onlyIfDerived": false
        },
        {
          "watch": "multiplierPercentage",
          "target": "maxValue",
          "compute": { "operator": "field", "name": "^maximumPercentage" },
          "onlyIfDerived": false
        }
      ],
      "itemRules": [
        {
          "id": "tracking-multiplier-min",
          "target": "multiplierPercentage",
          "rule": "greaterThanOrEqual",
          "comparedTo": "minValue",
          "message": "Must be greater than minimum% and less than maximum%",
          "condition": {
            "allOf": [
              { "field": "multiplierPercentage", "notEmpty": true },
              { "field": "minValue", "notEmpty": true }
            ]
          }
        },
        {
          "id": "tracking-multiplier-max",
          "target": "multiplierPercentage",
          "rule": "lessThanOrEqual",
          "comparedTo": "maxValue",
          "message": "Must be greater than minimum% and less than maximum%",
          "condition": {
            "allOf": [
              { "field": "multiplierPercentage", "notEmpty": true },
              { "field": "maxValue", "notEmpty": true }
            ]
          }
        }
      ]
    }
  },
  "rules": [
    {
      "id": "rule-description-max-length",
      "target": "ruleDescription",
      "rule": "maxLength",
      "maxValue": 250,
      "message": "Rule exceed 250 character limit.",
      "condition": { "field": "ruleDescription", "notEmpty": true }
    },
    {
      "id": "rule-summary-max-length",
      "target": "ruleSummary",
      "rule": "maxLength",
      "maxValue": 250,
      "message": "Rule Display exceed 250 character limit.",
      "condition": { "field": "ruleSummary", "notEmpty": true }
    },
    {
      "id": "minimum-percentage-max",
      "target": "minimumPercentage",
      "rule": "lessThan",
      "comparedTo": 10000,
      "message": "Cannot exceed 4 digit",
      "condition": { "field": "minimumPercentage", "notEmpty": true }
    },
    {
      "id": "maximum-percentage-max",
      "target": "maximumPercentage",
      "rule": "lessThan",
      "comparedTo": 10000,
      "message": "Cannot exceed 4 digit",
      "condition": { "field": "maximumPercentage", "notEmpty": true }
    },
    {
      "id": "maximum-percentage-min",
      "target": "maximumPercentage",
      "rule": "greaterThanOrEqual",
      "comparedTo": "minimumPercentage",
      "message": "Must be greater than minimum%",
      "condition": {
        "allOf": [
          { "field": "maximumPercentage", "notEmpty": true },
          { "field": "minimumPercentage", "notEmpty": true }
        ]
      }
    },
    {
      "id": "evaluation-date-required-when-earned-filled",
      "target": "performanceEvaluation.evaluationDate",
      "rule": "required",
      "message": "Required field",
      "condition": {
        "field": "performanceEvaluation.earnedMultipier",
        "notEmpty": true
      }
    },
    {
      "id": "earned-multiplier-required-when-date-filled",
      "target": "performanceEvaluation.earnedMultipier",
      "rule": "required",
      "message": "Required field",
      "condition": {
        "field": "performanceEvaluation.evaluationDate",
        "notEmpty": true
      }
    },
    {
      "id": "earned-multiplier-min",
      "target": "performanceEvaluation.earnedMultipier",
      "rule": "greaterThanOrEqual",
      "comparedTo": "performanceEvaluation.minValue",
      "message": "Must be greater than minimum% and less than maximum%",
      "condition": {
        "allOf": [
          { "field": "performanceEvaluation.earnedMultipier", "notEmpty": true },
          { "field": "performanceEvaluation.minValue", "notEmpty": true }
        ]
      }
    },
    {
      "id": "earned-multiplier-max",
      "target": "performanceEvaluation.earnedMultipier",
      "rule": "lessThanOrEqual",
      "comparedTo": "performanceEvaluation.maxValue",
      "message": "Must be greater than minimum% and less than maximum%",
      "condition": {
        "allOf": [
          { "field": "performanceEvaluation.earnedMultipier", "notEmpty": true },
          { "field": "performanceEvaluation.maxValue", "notEmpty": true }
        ]
      }
    }
  ],
  "observers": []
}
